<div class="container app-content-body">
    <div class="row">
        <div class="col-10">
            <h5 class="text-uppercase font-weight-bold app-text-accent">{{'privacy-statement.privacy-policy' | translate}}</h5>
        </div>
        <div class="col-2">
            <div class="form-group">
                <select [(ngModel)]="language" name="selectedLanguage" id="selectedLanguage" class="p-dropdown" (change)="onChangeLanguage($event)">
                  <option [value]="item.id" *ngFor="let item of languages">{{item.text}}</option>
                </select>  
              </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p>{{'privacy-statement.p1' | translate}}</p>
            <p>{{'privacy-statement.p2' | translate}}</p>
            <p>{{'privacy-statement.p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.introduction' | translate}}</h6>
            <p>{{'privacy-statement.introduction-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.data-we-get-about-you' | translate}}</h6>
            <p>{{'privacy-statement.data-we-get-about-you-p1' | translate}}</p>
            <p>{{'privacy-statement.data-we-get-about-you-p2' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.how-we-use-the-information-we-have-about-you' | translate}}</h6>
            <p>{{'privacy-statement.how-we-use-the-information-we-have-about-you-p1' | translate}}</p>
            <p>{{'privacy-statement.how-we-use-the-information-we-have-about-you-p2' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.how-we-share-or-disclose-your-information' | translate}}</h6>
            <p>{{'privacy-statement.how-we-share-or-disclose-your-information-p1' | translate}}</p>
            <p>{{'privacy-statement.how-we-share-or-disclose-your-information-p2' | translate}}</p>
            <p>{{'privacy-statement.how-we-share-or-disclose-your-information-p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.use-of-cookies' | translate}}</h6>
            <p>{{'privacy-statement.use-of-cookies-p1' | translate}}</p>
            <p>{{'privacy-statement.use-of-cookies-p2' | translate}}</p>
            <p>{{'privacy-statement.use-of-cookies-p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.protected-site' | translate}}</h6>
            <p>{{'privacy-statement.protected-site-p1' | translate}}</p>
            <p>{{'privacy-statement.protected-site-p2' | translate}}</p>
            <p>{{'privacy-statement.protected-site-p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.you-have-alternatives' | translate}}</h6>
            <p>{{'privacy-statement.you-have-alternatives-p1' | translate}}</p>
            <p>{{'privacy-statement.you-have-alternatives-p2' | translate}}</p>
            <p>{{'privacy-statement.you-have-alternatives-p3' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.independent-resource' | translate}}</h6>
            <p>{{'privacy-statement.independent-resource-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.changes-to-privacy-policy' | translate}}</h6>
            <p>{{'privacy-statement.changes-to-privacy-policy-p1' | translate}}</p>
            <p>{{'privacy-statement.changes-to-privacy-policy-p2' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.other-websites' | translate}}</h6>
            <p>{{'privacy-statement.other-websites-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.questions' | translate}}</h6>
            <p>{{'privacy-statement.questions-p1' | translate}}</p>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h6 class="app-text-accent text-uppercase">{{'privacy-statement.acknownledge' | translate}}</h6>
            <p>{{'privacy-statement.acknownledge-p1' | translate}}</p>
            <p>{{'privacy-statement.acknownledge-p2' | translate}}</p>
            <p>{{'privacy-statement.acknownledge-p3' | translate}}</p>
        </div>
    </div>
</div>
